import { render, staticRenderFns } from "./GoalsQuestion.vue?vue&type=template&id=5777dcc4&scoped=true"
import script from "./GoalsQuestion.vue?vue&type=script&lang=js"
export * from "./GoalsQuestion.vue?vue&type=script&lang=js"
import style0 from "./GoalsQuestion.vue?vue&type=style&index=0&id=5777dcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777dcc4",
  null
  
)

export default component.exports